import { render, staticRenderFns } from "./MainContents.vue?vue&type=template&id=bc43fcaa&scoped=true&"
import script from "./MainContents.vue?vue&type=script&lang=js&"
export * from "./MainContents.vue?vue&type=script&lang=js&"
import style0 from "./MainContents.vue?vue&type=style&index=0&id=bc43fcaa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc43fcaa",
  null
  
)

/* custom blocks */
import block0 from "./MainContents.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports